var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"popup-wrapper"},[_c('div',{staticClass:"popup-container center loading"},[_c('div',{staticClass:"popup"},[_c('div',{staticClass:"popup-content"},[_c('IcLoading',{staticClass:"icn x2"}),_c('p',{staticClass:"txt mt12 mb0"},[_vm._v("Loading")])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }